var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.Refuse"),
        width: "400px",
        "custom-class": "cargo-form-dialog",
        "close-on-click-modal": false,
        "append-to-body": _vm.appendToBody
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.handleClose
      }
    },
    [
      _c("div", [
        _c("span", [_vm._v(_vm._s(_vm.rejectTips))]),
        _c(
          "span",
          [
            _c("el-input", {
              attrs: { type: "textarea", rows: 10 },
              model: {
                value: _vm.remark,
                callback: function($$v) {
                  _vm.remark = $$v
                },
                expression: "remark"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "span",
        {
          staticStyle: { padding: "10px" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
          ),
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }